export const langAppId = {
    de: '0a1e5fb9-d869-4ef6-8aa0-983e24310671',
    en: '92b9f6ac-6623-44f2-994c-a8dd0a8c28f4',
    us: '96d60423-a273-4d0e-be4e-161d14f3fa8e',
    au: 'a0758237-aa5d-4bd6-a9d7-6c334a9fbd06',
    za: 'e046d631-3da3-466d-ac90-eaf50baef4ee',
    fr: 'e7387205-6a17-44f3-8b7c-32a67b0df84b',
    jp: '2de0e8ed-b74e-40d0-8394-c32a2c70f938',
    cn: 'a6210c8b-db95-4a5f-80d4-cd8caf849e1c',
    kr: '813a2f6c-08f7-48dd-a807-7d6069d957ec',
};

export const appIdMap = {
    de: langAppId.de,
    us: langAppId.us,
    ca: langAppId.en,
    au: langAppId.au,
    za: langAppId.za,
    uk: langAppId.en,
    eu: langAppId.en,
    kr: langAppId.kr,
    fr: langAppId.fr,
    jp: langAppId.jp,
    cn: langAppId.cn,
};

export const regionCode: Record<string, number> = {
    us: 1,
    ca: 2,
    au: 3,
    za: 4,
    uk: 5,
    eu: 6,
    de: 7,
    kr: 8,
    fr: 12,
    cn: 13,
    jp: 14,
};

// 采用新聊天窗窗样式的区域
export const newChatBoxStyleSite = ['us', 'ca', 'au', 'za', 'uk', 'eu', 'de', 'fr', 'jp', 'cn', 'kr', 'es', 'it', 'nl', 'ph'];

export const langTxt: any = {
    us: `I'm online! Your Intelligent assistant is here ✨`,
    en: `I'm online! Your Intelligent assistant is here ✨`,
    de: 'Ich bin online! Dein intelligenter Assistent ist da. ✨',
    jp: 'オンラインです！あなたの賢いアシスタントがここにいます。 ✨',
    cn: '您的智能助手在线中~ ✨',
    fr: 'Je suis en ligne ! Ton assistant intelligent est là. ✨',
    kr: '온라인 접속 완료! 당신의 똑똑한 어시스턴트가 여기 있어요.',
};

export const regionUrl: any = {
    fr: 'https://m-9ae05e11-c6d8-ed11-aed0-000d3a64d144.eu.omnichannelengagementhub.com',
    jp: 'https://m-9ae05e11-c6d8-ed11-aed0-000d3a64d144.eu.omnichannelengagementhub.com',
    cn: 'https://m-9ae05e11-c6d8-ed11-aed0-000d3a64d144.eu.omnichannelengagementhub.com',
    kr: 'https://m-9ae05e11-c6d8-ed11-aed0-000d3a64d144.eu.omnichannelengagementhub.com',
    other: 'https://unq9ae05e11c6d8ed11aed0000d3a64d-crm4.omnichannelengagementhub.com',
};

export const jpChatStyles = {
    confirmationPaneProps: {
        controlProps: {
            titleText: 'チャットを終了してもよろしいですか',
            hideSubtitle: true,
            confirmButtonText: 'はい',
            cancelButtonText: 'いいえ',
        },
        styleProps: {
            confirmButtonStyleProps: {
                fontSize: '12px',
            },
            cancelButtonStyleProps: {
                fontSize: '12px',
            },
        },
    },
};

export const originPlayload = {
    $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
    type: 'AdaptiveCard',
    version: '1.3',
    body: [
        {
            type: 'TextBlock',
            text: 'Ready to try the ECOFLOW AI Assistant?',
            weight: 'bolder',
            style: 'heading',
        },
        {
            type: 'TextBlock',
            size: 'Medium',
            text: 'This assistant is designed solely to support your interactions with ECOFLOW products.',
        },
        {
            type: 'TextBlock',
            size: 'Medium',
            text: '⚠️Please note:',
            weight: 'bolder',
        },
        {
            type: 'TextBlock',
            wrap: true,
            text: '🔹 AI-generated responses are for reference only and do not constitute professional advice or official commitments.\n\n🔹 For important decisions or safety-related issues, please consult human support or official documentation.\n\n🔹 Do not enter any personal or sensitive information, such as ID numbers, bank details, or content related to politics or religion.\n\n🔹 The information you enter during interaction may be used for AI model optimization and service improvement, in full compliance with applicable privacy regulations.',
            spacing: 'medium',
        },
        {
            type: 'TextBlock',
            text: '🔹 For more details, see [Privacy Policy](https://account.ecoflow.com/agreement/en-us/PrivacyPolicy.html) and [AI Assistant Service Disclaimer](https://account.ecoflow.com/agreement/en-us/ECOFLOW-AI-Assistant-Service-Disclaimer.html)',
        },
        {
            type: 'Input.Toggle',
            size: 'small',
            id: '{"Id":"e4bdf7cb-995e-ec11-8f8f-000d3a31376e","Name":"Consent","IsOption":false,"Order":3,"IsRequired":true,"QuestionText":"I have read and agree to the terms above."}',
            title: '***I have read and agree to the terms above**',
            valueOn: 'True',
            valueOff: 'False',
            value: 'false',
            isRequired: true,
            errorMessage: 'You must agree  before continuing.',
        },
        {
            type: 'TextBlock',
            isSubtle: true,
            text: 'Fields marked with * are mandatory.',
            wrap: true,
        },
    ],
    actions: [
        {
            type: 'Action.Submit',
            title: 'Start Chatting',
            data: {
                Type: 'InputSubmit',
            },
        },
    ],
};

export const getErrorFun = (appId: string, orgUrl: string) =>
    `(function(el){el.parentNode.removeChild(el);var s=document.createElement('script');s.src='https://ocprodpubliceurgs.blob.core.windows.net/livechatwidget/scripts/LiveChatBootstrapper.js';s.setAttribute('id', 'Microsoft_Omnichannel_LCWidget');s.setAttribute('data-app-id', ${appId});s.setAttribute('data-lcw-version', 'prod');s.setAttribute('data-org-id', '9ae05e11-c6d8-ed11-aed0-000d3a64d144');s.setAttribute('data-org-url', ${orgUrl});document.body.appendChild(s);})(this);`;

export const openCustonChatList = ['us', 'ca', 'au', 'za', 'uk', 'eu', 'de', 'fr', 'jp', 'cn', 'kr', 'es', 'it', 'nl', 'ph'];
